export const MAX_IMAGE_SIZE_MB = 20;
